import sectionCardVitalSliderCss from '../css-snippets/section-card-vital-slider';

const html = `
<style>${sectionCardVitalSliderCss}</style>
<div data-attribute="card-container" id="card-container-unique-id" data-id="unique-id" data-background="#daecf0"
  data-top-padding="true" data-bottom-padding="true" data-color="#000000" data-text-color="#000000"
  style="background-color: #daecf0; color: #000000; --color-text: #000000; --color-background: #daecf0; --item-background: #ffffff; --item-des-background: #daecf0; ">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div class="container">
      <div class="wrap-card">
        <div data-show-title="true" data-attribute="title-card" class="title-card">
          <h2 style="text-align: center;">How to us</h2>
        </div>
        <div class="wrap-content">
          <div class="swiper swiper-vital-unique-id">
            <div data-col-per-view="4" data-space-between="16" data-item-background="#ffffff"
              data-item-des-background="#daecf0" data-attribute="list-item" class="swiper-wrapper">

              <div data-attribute="item" class="swiper-slide">
                <div class="wrap-item">
                  <div class="wrap-img">
                    <img data-attribute="image-item"
                      src="https://cdn.skyfastimg.com/images/2026/04/02/image-69cdeb690398bc19f985dc71.png" alt="">
                  </div>
                  <div data-padding="true" data-attribute="description-item" class="description-item">
                    <p>Mix 1 scoop of Vital Beauty into 280-400ml of water.</p>
                  </div>
                </div>
              </div>

              <div data-attribute="item" class="swiper-slide">
                <div class="wrap-item">
                  <div class="wrap-img">
                    <img data-attribute="image-item"
                      src="https://cdn.skyfastimg.com/images/2026/04/02/image-69cdeb08bfbdd2582ac74908.png" alt="">
                  </div>
                  <div data-padding="true" data-attribute="description-item" class="description-item">
                    <p>Mix 1 scoop of Vital Beauty into 280-400ml of water.</p>
                  </div>
                </div>
              </div>

              <div data-attribute="item" class="swiper-slide">
                <div class="wrap-item">
                  <div class="wrap-img">
                    <img data-attribute="image-item"
                      src="https://cdn.skyfastimg.com/images/2026/04/02/image-69cdeb13aa09201551ad17d9.png" alt="">
                  </div>
                  <div data-padding="true" data-attribute="description-item" class="description-item">
                    <p>Mix 1 scoop of Vital Beauty into 280-400ml of water.</p>
                  </div>
                </div>
              </div>

              <div data-attribute="item" class="swiper-slide">
                <div class="wrap-item">
                  <div class="wrap-img">
                    <img data-attribute="image-item"
                      src="https://cdn.skyfastimg.com/images/2026/04/02/image-69cdeb35b3f7cbb920db9897.png" alt="">
                  </div>
                  <div data-padding="true" data-attribute="description-item" class="description-item">
                    <p>Mix 1 scoop of Vital Beauty into 280-400ml of water.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
